<template>
  <div>
    {{ checkAlertNotification }}
    <app-loader v-if="pageLoader" style="z-index: 9999 !important" />
    <div>
      <!-- <app-forgot v-if="true"></app-forgot> -->
      <!--  v-if="forgotPage" -->
      <app-register v-if="page_type == 'register'"></app-register>
      <app-account v-if="page_type == 'real-account'"></app-account>
      <app-login v-if="page_type == 'login'"></app-login>
      <app-reset-password v-if="page_type == 'reset'"></app-reset-password>
    </div>
    <app-register v-if="registerPage == 'register'"></app-register>
    <div class="mainHeader d-flex align-items-center justify-content-between"
      :class="{ 'mainHeader d-flex align-items-center justify-content-between change-bg red-background': isEWActive }">
      <balance-section></balance-section>
      <div class="d-flex align-items-center rightInterSpace">
        <div class="mainLogo hide-for-desktop">
          <router-link to="/" v-if="$parent.$parent.theme">
            <img :src='DARK_LOGO_URL' alt="Logo"
              :style="product == 'Copyrack'?'width: 100px; max-width: 100px;': product == 'Capital-Street'? 'width: 60px;' : ''" />
          </router-link>
          <router-link to="/" v-if="!$parent.$parent.theme">
            <img :src='LIGHT_LOGO_URL' alt="Logo"
              :style="product == 'Copyrack'?'width: 100px; max-width: 100px;': product == 'Capital-Street'? 'width: 60px;' :''" />
          </router-link>
        </div>
        <!-- <div class="vueWi mr-4 eqlSpace">
					<div class="toggle-button-cover d-flex align-items-center">
				        <input type="checkbox" id="sdf" @click="isToggled = !isToggled">
					    <label>
					      <span></span>
					      One Click Trading
					    </label>
					</div>
				</div> -->
        <ul class="header-nav d-flex align-items-center mr-4 hide-for-mobile hide-for-tablet ">
          <!-- <li class="active"><a href="#">Trading</a></li> -->
          <!-- <li><a @click.prevent="page_type = 'login'" href="#">Log in</a></li> -->
          <!-- <li>
            <a @click.prevent="page_type = 'register'" href="#">Open Demo Account</a>
          </li> -->
          <!-- <li><a @click.prevent="page_type = 'real-account'" href="#">Open Real Account</a></li> -->
        </ul>
        <button type="button" class="btn appButton hide-for-desktop mr-3" v-if="get_user.username">
          Hello {{ (get_user.username || '').split("$$")[1] || "-" }}
        </button>
        <div class="vueWi mr-4 eqlSpace">
          <a href="#" :class="networkStatus[wsStatus]" :title="statusText[wsStatus]">
            <feather size="20" type="wifi"></feather>
          </a><!--  class="yellow"  -->
        </div>

        <!-- <div class="vueNotifiy mr-4 eqlSpace">
          <a href="#" data-toggle="dropdown"
            ><feather size="20" type="bell"></feather>
          </a>
          <div class="dropdown-menu customNotify">
            <div class="no_notification text-center">
              <img
                src="../../../../static/website/images/cion-notification.svg"
                alt="Icon"
              />
              <p>No notification</p>
            </div>
          </div>
        </div>
        <div class="vueMail mr-4 eqlSpace">
          <a href="#" data-toggle="dropdown"
            ><feather size="20" type="mail"></feather>
          </a>
          <div class="dropdown-menu customNotify">
            <div class="no_notification text-center">
              <img src="../../../../static/website/images/noMessage.svg" alt="Icon" />
              <p>No Message</p>
            </div>
          </div>
        </div> -->
        <language-dropdown></language-dropdown>

        <div class="rightNavOpen eqlSpace">
          <a @click="" href="#" class="userClick f-14 justify-content-center align-items-center"
            @click.stop.prevent="openHeader = !openHeader">
            <!-- <feather size="20" type="user"></feather> -->
            <span class="rounded-circle">
              <span v-if="profileData.FIRSTNAME">{{
                profileData.FIRSTNAME.charAt(0).toUpperCase()
                }}</span>
              <span v-else-if="profileData.EMAIL">{{
                profileData.EMAIL.charAt(0).toUpperCase()
                }}</span>
            </span>
            <!-- <img src="https://dev.finvasia.com:6020/api/get/user/avatar?user=25&img=gurpreet_ava.png" alt="User" class="rounded-circle"/> -->
          </a>
        </div>
      </div>
      <!-- <div class="bottom-header-bar-wrap d-none">
        <div class="bottom-header-row">
          <ul>
            <li>
              <a href="#"
                ><svg
                  width="24"
                  height="20"
                  viewBox="0 0 24 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M11.9129 0.5L23 10.8014L22.4933 11.3563L11.917 1.52963L1.51118 11.3565L1 10.8057L11.9129 0.5Z"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M4.14647 8.93704V17.6138C4.14647 18.2388 4.64878 18.7455 5.26841 18.7455H18.7317C19.3514 18.7455 19.8537 18.2388 19.8537 17.6138V8.93704H20.6016V17.6138C20.6016 18.6555 19.7645 19.5 18.7317 19.5H5.26841C4.23569 19.5 3.39851 18.6555 3.39851 17.6138V8.93704H4.14647Z"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M9.75619 13.0868C9.75619 14.3369 10.7608 15.3503 12.0001 15.3503C13.2393 15.3503 14.244 14.3369 14.244 13.0868C14.244 11.8367 13.2393 10.8233 12.0001 10.8233C10.7608 10.8233 9.75619 11.8367 9.75619 13.0868ZM12.0001 10.0688C10.3477 10.0688 9.00823 11.42 9.00823 13.0868C9.00823 14.7536 10.3477 16.1048 12.0001 16.1048C13.6524 16.1048 14.9919 14.7536 14.9919 13.0868C14.9919 11.42 13.6524 10.0688 12.0001 10.0688Z"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M11.9129 0.5L23 10.8014L22.4933 11.3563L11.917 1.52963L1.51118 11.3565L1 10.8057L11.9129 0.5Z"
                    stroke="#4187F8"
                    stroke-width="0.3"
                    stroke-linecap="square"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M4.14647 8.93704V17.6138C4.14647 18.2388 4.64878 18.7455 5.26841 18.7455H18.7317C19.3514 18.7455 19.8537 18.2388 19.8537 17.6138V8.93704H20.6016V17.6138C20.6016 18.6555 19.7645 19.5 18.7317 19.5H5.26841C4.23569 19.5 3.39851 18.6555 3.39851 17.6138V8.93704H4.14647Z"
                    stroke="#4187F8"
                    stroke-width="0.3"
                    stroke-linecap="square"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M9.75619 13.0868C9.75619 14.3369 10.7608 15.3503 12.0001 15.3503C13.2393 15.3503 14.244 14.3369 14.244 13.0868C14.244 11.8367 13.2393 10.8233 12.0001 10.8233C10.7608 10.8233 9.75619 11.8367 9.75619 13.0868ZM12.0001 10.0688C10.3477 10.0688 9.00823 11.42 9.00823 13.0868C9.00823 14.7536 10.3477 16.1048 12.0001 16.1048C13.6524 16.1048 14.9919 14.7536 14.9919 13.0868C14.9919 11.42 13.6524 10.0688 12.0001 10.0688Z"
                    stroke="#4187F8"
                    stroke-width="0.3"
                    stroke-linecap="square"
                  />
                </svg>

                Home</a
              >
            </li>
            <li>
              <a href="#">
                <svg
                  width="20"
                  height="21"
                  viewBox="0 0 20 21"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M15.2826 11.5652C15.2826 11.2891 15.5065 11.0652 15.7826 11.0652H19C19.2761 11.0652 19.5 11.2891 19.5 11.5652V20C19.5 20.2761 19.2761 20.5 19 20.5H15.7826C15.5065 20.5 15.2826 20.2761 15.2826 20V11.5652ZM7.8913 12.8696C7.8913 12.5934 8.11516 12.3696 8.3913 12.3696H11.6087C11.8848 12.3696 12.1087 12.5934 12.1087 12.8696V20C12.1087 20.2761 11.8848 20.5 11.6087 20.5H8.3913C8.11516 20.5 7.8913 20.2761 7.8913 20V12.8696ZM0.5 14.1739C0.5 13.8978 0.723858 13.6739 1 13.6739H4.21739C4.49353 13.6739 4.71739 13.8978 4.71739 14.1739V20C4.71739 20.2761 4.49353 20.5 4.21739 20.5H1C0.723857 20.5 0.5 20.2761 0.5 20V14.1739Z"
                    stroke="#999A9B"
                  />
                  <path
                    d="M19.2025 1L11.2858 9.26087L7.11914 4.91304L0.869141 11.4348"
                    stroke="#999A9B"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M14.2031 1H19.2031V6.21739"
                    stroke="#999A9B"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>

                Markets</a
              >
            </li>
            <li>
              <a href="#">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12.2272 0.851051H2.62012C1.65542 0.851051 0.873373 1.61311 0.873373 2.55315V15.3189C0.873373 16.259 1.65542 17.021 2.62012 17.021H12.2272V17.8721H2.62012C1.17307 17.8721 0 16.729 0 15.3189V2.55315C0 1.14309 1.17307 0 2.62012 0H12.2272C13.6743 0 14.8473 1.14309 14.8473 2.55315V11.4892H13.974V2.55315C13.974 1.61311 13.1919 0.851051 12.2272 0.851051Z"
                    fill="#999A9B"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M11.1808 11.5551C11.2963 11.4063 11.4768 11.3188 11.6683 11.3188H17.1764C17.3554 11.3188 17.5253 11.3952 17.6415 11.5278L19.8537 14.0538C20.0542 14.2828 20.0479 14.6214 19.8392 14.8432L15.5547 19.3952C15.4106 19.6074 15.1344 19.8899 14.7401 19.9751C14.2833 20.0737 13.8336 19.8783 13.4571 19.4122L9.15865 14.9839C8.95334 14.7723 8.935 14.4472 9.11528 14.215L11.1808 11.5551ZM11.7986 12.1699L9.94563 14.5561L14.1209 18.8576L14.1342 18.8745C14.2593 19.0323 14.3589 19.0993 14.4214 19.1269C14.4779 19.1519 14.5177 19.1514 14.5511 19.1442C14.641 19.1248 14.7545 19.0351 14.831 18.9186C14.8489 18.8915 14.8704 18.8631 14.8969 18.835L19.0389 14.4345L17.0556 12.1699H11.7986ZM16.9771 12.0803C16.9771 12.0802 16.9772 12.0804 16.9771 12.0803V12.0803Z"
                    fill="#999A9B"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M13.4339 15.5956L12.2221 13.9496L12.9317 13.4535L14.1435 15.0995C14.3177 15.3362 14.6789 15.3362 14.8532 15.0995L16.0649 13.4535L16.7746 13.9496L15.5628 15.5956C15.0401 16.3055 13.9565 16.3055 13.4339 15.5956Z"
                    fill="#999A9B"
                  />
                  <path
                    d="M3.15745 4.00011C3.15745 3.76509 3.35296 3.57458 3.59413 3.57458H10.7907C11.0319 3.57458 11.2274 3.76509 11.2274 4.00011C11.2274 4.23512 11.0319 4.42563 10.7907 4.42563H3.59413C3.35296 4.42563 3.15745 4.23512 3.15745 4.00011Z"
                    fill="#999A9B"
                  />
                  <path
                    d="M3.15745 7.57469C3.15745 7.33967 3.35296 7.14916 3.59413 7.14916H7.98378C8.22496 7.14916 8.42047 7.33967 8.42047 7.57469C8.42047 7.8097 8.22496 8.00021 7.98378 8.00021H3.59413C3.35296 8.00021 3.15745 7.8097 3.15745 7.57469Z"
                    fill="#999A9B"
                  />
                  <path
                    d="M3.15745 11.1484C3.15745 10.9134 3.35296 10.7229 3.59413 10.7229H6.58031C6.82148 10.7229 7.017 10.9134 7.017 11.1484C7.017 11.3834 6.82148 11.574 6.58031 11.574H3.59413C3.35296 11.574 3.15745 11.3834 3.15745 11.1484Z"
                    fill="#999A9B"
                  />
                </svg>

                Orders</a
              >
            </li>
            <li>
              <a href="#"><span class="userImageCol">...</span>More</a>
            </li>
          </ul>
        </div>
      </div> -->
    </div>
    <!--Open right Menu-->
    <div class="sidenavMain-menu" :class="openHeader ? 'active' : ''">
      <div class="sideNav openHeader d-flex flex-column justify-content-between">
        <div class="closeHeaderBtn" @click="openHeader=false">
          <span>&#x2716</span>
        </div>
        <ul>
          <li><router-link to="/">{{$t('main_trading')}}</router-link></li>
          <li><router-link to="/leaders" v-if="['market101'].includes(product)">{{$t('copy_trade')}}</router-link></li>
          <li @click.prevent.stop="changeTab('Profile')"><a href="#">{{$t('profile')}}</a></li>
          <!-- <li><a href="#">Portfolio <sup class="green">Upcoming</sup></a></li> -->
          <li><router-link to="portfolio-balance">{{$t('portfolio')}} </router-link></li>
          <li @click.prevent.stop="changeTab('Trading View')" v-show='!(isMobileGrid())''>
              <a href="#">{{$t(' view_modes')}}</a>
          </li>
          <!-- <li @click.prevent.stop="headerTab = 'Reports Setting'"><a href="#">{{$t('main_trading')}}</a></li> -->
          <li><a href="#trade-report" @click.prevent="callReport()">{{$t('reports')}}</a></li>
          <li @click.prevent.stop="headerTab = 'Settings'"><a href="#">{{$t('settings')}}</a></li>
          <li>
            <a class="d-flex align-items-center justify-content-between" href="#">
              <span>{{$t('theme')}}</span>
              <div class="toggle-button-cover">
                <input type="checkbox" id="sdf" v-model="$root.$children[0].theme" @change="themeChange()" />
                <label for="sdf" data-off="I'm Unchecked" data-on="I'm Checked">
                  <span></span>
                </label>
              </div>
            </a>
          </li>
          <li v-if="get_user.loggedIn">
            <a href="#app-logout" @click.prevent="logOut()">{{$t('logout')}}</a>
          </li>
          <!-- <li v-else><a href="#app-logout" @click.prevent="logOut()">Logout</a></li> -->
        </ul>
        <div class="px-3 mb-2 ">
          <div class="themeBG border-top mb-2" style="height: 1px;"></div>
          <div class="d-flex justify-content-between w-100">
            <span class="f-10">{{ version }}</span>
            <div>
              <span class="f-10">{{$t('powered_by')}}:</span>
              <a href="https://www.acttrader.com/" target="_blank">
                <span class="f-10 white">{{$t('act_trader')}} </span>
              </a>
            </div>
            <!-- <span class="f-10">Act Trader Techonologies LTD</span> -->
          </div>
        </div>
      </div>
    </div>
    <sidebar-popup :tab="headerTab" v-if="headerTab != ''"></sidebar-popup>

    <!-- *** First Default Modal: opens on login *** -->
    <div class="header-modal" v-if="get_user.loggedIn && isFirstModalOpen && product == 'Magnofx'"
      @click="closeFirstModal">
      <div class="header-modal-overlay"></div>
      <div class="header-modal-box" @click.stop="">
        <button class="header-modal-close" @click="closeFirstModal">&#x2716;</button>
        <div class="header-modal-body">
          <a href="https://trade1.magnofx.com/" target="_blank">
            <img src="../../../../static/website/images/magnoFxBanner.jpg" alt="" />
          </a>
        </div>

      </div>
    </div>

    <!-- Second modal moved to right-sec.vue and triggered via $root event -->

  </div>
</template>

<script>
  import sideBar_popUp from "./sidebar-popup";
  import balance_section from "./header-balance";
  import app_login from "../user/login";
  import reset_password from "../user/reset-password";
  import language_dropdown from "./language";
  // import app_forgot from './forgot-password'
  import app_register from "./register";
  import app_account from "./real-account";
  import { commonAllmixins } from "@/plugins/commonAll";
  import { Const } from "@/plugins/commonAll/provider/lib/const.cls";
  import * as types from "@/types";
  const product = process.env.product;
  export default {
    name: "app-header",
    mixins: [commonAllmixins],
    data() {
      return {
        pageLoader: false,
        openHeader: false,
        countryList: false,
        headerTab: "",
        page_type: "",
        registerPage: "",
        isToggled: false,
        isEWActive: false,
        loginPage: false,
        usrLogin: false,
        DARK_LOGO_URL: process.env.LOGO_URL_DARK,
        LIGHT_LOGO_URL: process.env.LOGO_URL_LIGHT,
        DARK_LOGO_UPDATED_URL: process.env.LOGO_URL_DARK,
        LIGHT_LOGO_UPDATED_URL: process.env.LOGO_URL_LIGHT,
        currencyIcon: { EUR: "€", USD: "$", GBP: "£", CHF: "CHF", JPY: "¥", AUD: "$" },
        networkStatus: { 0: "yellow", 1: "green", 2: "orange", 3: "red" },
        statusText: { 0: "Connecting...", 1: "Active", 2: "Inactive", 3: "closed" },
        product,
        version: process.env.VERSION || "",
        timerId: null,
        showPopup: false,
        isFirstModalOpen: true,
      };
    },
    components: {
      sidebarPopup: sideBar_popUp,
      appLogin: app_login,
      appResetPassword: reset_password,
      languageDropdown: language_dropdown,
      // appForgot:app_forgot,
      appRegister: app_register,
      appAccount: app_account,
      balanceSection: balance_section,
    },
    watch: {
      $route(to, form) {
        this.openHeader = false;
        this.headerTab = "";
        if (this.get_user.loggedIn) {
        } else {
          this.page_type = "login";
        }
        // document.title = ":: ActTrader Web Application ::";
        if ($(document.body).hasClass("maximizeToggle")) {
          $(document.body).removeClass("maximizeToggle");
        }
      },
    },
    methods: {
      closeFirstModal() {
        this.isFirstModalOpen = false;
        // Notify right-sec.vue (sibling) to open the second modal
        this.$root.$emit('open-second-modal');
      },
      themeChange() {
        this.openHeader = false;
      },
      changeTab(val) {
        if (this.get_user.loggedIn) {
          this.headerTab = val;
        } else {
          this.page_type = "login";
        }
      },
      logOut() {
        this.$store.dispatch(types.RUN_LOGOUT, {
          globalParams: {},
          localParams: { parameter: this },
        });
      },
      callReport() {
        if (this.get_user.loggedIn) {
          this._runGetAccountReport({ globalParams: {}, localParams: { parameter: this } });
        } else {
          this.page_type = "login";
        }
      },
      displayError(getMessage, type) {
        this.$notify({
          group: "foo",
          type: type && type == null ? "error" : type,
          text: getMessage,
          duration: 10000,
          closeOnClick: true,
        });
      },
      displayEW(errorJson, type) {

        this.isEWActive = true
        this.$notify({
          group: "foo",
          type: type && type == null ? "error" : type,
          title: (errorJson.title || 'Minimal Equity Warning!'),
          text: errorJson.msg,
          duration: 100000,
          position: 'top',
          closeOnClick: true,
          max: 2
        });

        setTimeout(() => {
          this.isEWActive = false
        }, 1000);
      },
      displayMarginCall(errorJson, type) {

        this.isEWActive = true
        this.$notify({
          group: "foo",
          type: type && type == null ? "error" : type,
          title: (errorJson.title || 'Position Closed Due To Margin Call'),
          text: errorJson.msg,
          duration: 1000000000,
          position: 'top',
          closeOnClick: true,
          max: 200
        });

        setTimeout(() => {
          this.isEWActive = false
        }, 1000);
      },
      callTrigerdAlert() {
        this._runGetTriggeredPriceAlert({
          globalParams: {},
          localParams: { parameter: this },
        });
      },
      callActiveAlert() {
        this._runGetActivePriceAlert({
          globalParams: {},
          localParams: { parameter: this },
        });
      },
      isMobileGrid() {
        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
          return true
        } else {
          return false
        }
      },
      resetInactivityTimer() {
        if (this.get_user.loggedIn) {
          if (this.timerId) {
            clearTimeout(this.timerId);
          }
          // Start new 30-minute timer after last interaction
          this.timerId = setTimeout(() => {
            // this.showPopup = true;
            this.changeTab('Idle Session')
          }, 30 * 60 * 1000); // 30 minutes
        }
      },
    },
    computed: {
      checkAlertNotification() {
        if (this.priceAlertNotification.length > 0) {
          let new_alert = this.priceAlertNotification[0];
          let active_alert = this.$store.getters[Const.GET_ACTIVE_PRICE_ALERT];
          let trigred_alert = this.$store.getters[Const.GET_TRIGGERED_PRICE_ALERT];
          if (new_alert.msg_type == "T") {
            if (active_alert.length > 0) {
              active_alert = active_alert.filter((val) => val.AlertID != new_alert.AlertID);
              this.$store.commit(Const.SET_ACTIVE_PRICE_ALERT, active_alert);
            } else {
              this.callActiveAlert();
            }
            if (trigred_alert.length > 0) {
              trigred_alert.unshift(new_alert);
              this.$store.commit(Const.SET_TRIGGERED_PRICE_ALERT, trigred_alert);
            } else {
              this.callTrigerdAlert();
            }
            this.displayError(
              "New Price Alert Triggered of " +
              new_alert.Symbol +
              " for " +
              new_alert.Type +
              " At Price: " +
              new_alert.Price +
              "\"" + new_alert.Commentary + "\"",
              "success"
            );
          } else if (new_alert.msg_type == "I") {
            if (active_alert.length > 0) {
              active_alert.unshift(new_alert);
              this.$store.commit(Const.SET_ACTIVE_PRICE_ALERT, active_alert);
            } else {
              this.callActiveAlert();
            }
            this.displayError(
              "New Price Alert Created of " +
              new_alert.Symbol +
              " for " +
              new_alert.Type +
              " At Price: " +
              new_alert.Price +
              " \"" + new_alert.Commentary + "\"",
              "success"
            );
          } else if (new_alert.msg_type == "U") {
            for (let index in active_alert) {
              if (active_alert[index].AlertID == new_alert.AlertID) {
                active_alert[index].Price = new_alert.price;
                active_alert[index].Commentary = new_alert.Commentary;
                active_alert[index].Type = new_alert.Type;
                this.displayError(
                  "New Price Alert Updated of " +
                  active_alert[index].Symbol +
                  " for " +
                  new_alert.Type +
                  " At Price: " +
                  new_alert.price +
                  "\"" + new_alert.Commentary + "\"",
                  "success"
                );
              }
            }
            this.$store.commit(Const.SET_ACTIVE_PRICE_ALERT, active_alert);
          }
          else if (new_alert.msg_type == "EW") {
            this.displayEW(new_alert, "error");
            this.$store.commit(Const.SET_ACTIVE_PRICE_ALERT, active_alert);
          }
          else if (new_alert.msg_type == "MC") {
            this.displayMarginCall(new_alert, "error");
            this.$store.commit(Const.SET_ACTIVE_PRICE_ALERT, active_alert);
          }
          else if (new_alert.msg_type == "ME") {
            this.displayError(new_alert.msg, "error");
            this.$store.commit(Const.SET_ACTIVE_PRICE_ALERT, active_alert);
          }
          let notificationData = this.priceAlertNotification.filter(
            (val) => val.AlertID != new_alert.AlertID
          );
          this.$store.commit(Const.SET_PRICE_ALERT_NOTIFICATON, notificationData);
          if (this.priceAlertNotification.length > 0) {
            this.checkAlertNotification();
          }
        }
        // console.log('this.userSettings', this.userSettings) 
        if (parseInt(this.userSettings.font_size) == 1) {
          document.body.classList.add('small');
          document.body.classList.remove('large');
          document.body.classList.remove('medium');
        } else if (parseInt(this.userSettings.font_size) == 3) {
          document.body.classList.add('large');
          document.body.classList.remove('small');
          document.body.classList.remove('medium');
        } else {
          document.body.classList.add('medium');
          document.body.classList.remove('small');
          document.body.classList.remove('large');
        }
      },
    },
    created() {
      this._runGetCurrencyPairs({ globalParams: {}, localParams: { parameter: this } });
      if (this.get_user.loggedIn) {
        this._runGetpriceShift({ globalParams: {}, localParams: { parameter: this } });
        // this.usrLogin = false
        this.page_type = "";
        this.$store.dispatch(types.RUN_STATE_LOAD, {
          globalParams: {},
          localParams: { parameter: this },
        });
      } else {
        this.page_type = "login";
      }

      this.isMobileGrid() ? document.body.classList.add('largeFont') : '';

      this._runGetUserAccount({ globalParams: {}, localParams: { parameter: this } });
      this._runGetUserSettings({ globalParams: {}, localParams: { parameter: this } });
      this._runGetRawObject({ globalParams: {}, localParams: { parameter: this } });
      /*this._runGetActivePriceAlert({'globalParams' : {} ,'localParams' : {'parameter' : this}})
              this._runGetTriggeredPriceAlert({'globalParams' : {} ,'localParams' : {'parameter' : this}})
              if(this.$route.name == 'custom-view'){
                  this._runGetRawObject({ 'globalParams' : {},'localParams' : { 'parameter' : this} })
              }*/
    },
    mounted() {
      const _that = this
      $(document).on("click", function (event) {
        if (!$(event.target).closest(".openHeader").length) {
          _that.openHeader = false;
        }
        if (!$(event.target).closest(".headerTab").length) {
          if (_that.headerTab != 'Idle Session') _that.headerTab = "";
        }
      });
      window.addEventListener("mousemove", this.resetInactivityTimer);
      window.addEventListener("keydown", this.resetInactivityTimer);
      window.addEventListener("scroll", this.resetInactivityTimer);
      window.addEventListener("touchstart", this.resetInactivityTimer);
      this.resetInactivityTimer();
    },
    beforeUnmount() {
      clearTimeout(this.timerId);
      window.removeEventListener("mousemove", this.resetInactivityTimer);
      window.removeEventListener("keydown", this.resetInactivityTimer);
      window.removeEventListener("scroll", this.resetInactivityTimer);
      window.removeEventListener("touchstart", this.resetInactivityTimer);
    },
  };
</script>
<style>
  .change-bg {
    background-color: inherit;
    /* Initial color */
    transition: background-color 0.5s ease;
  }

  .change-bg.red-background {
    animation: flashRed 3s ease;
  }

  @keyframes flashRed {
    0% {
      background-color: red;
    }

    100% {
      background-color: inherit;
      /* Revert to original color */
    }
  }


  /* ========== End Header Sequential Modals ========== */
</style>


// WEBPACK FOOTER //
// src/components/website/shared/header.vue